import React from "react";
import {DialogContent} from "@mui/material";
import {OrderModel} from "../../../../../shared/models/order/order-item.model";
import Message from "../../../../../components/message";
import {MessageSections} from "../../../../../components/message/message";
import {useAppSelector} from "../../../../../../redux/store";
import {StandardDialog, StandardDialogFooter} from "../../../../../components/dialogs/standard-dialog/standard-dialog";
import {AdditionalServiceModel} from "../../../../../shared/models/order/additional-service.model";

export const OnHoldDialog = ({isOnHold, order, open, updateData, handleClose}: AdditionalServiceOnHoldDialogProps) => {
    const {additionalServices} = useAppSelector(state => state.staticDataReducer)

    function setOrderOnHold() {
        const onHoldService = additionalServices.find(service => service.additionalServiceId === 6);
        const filteredOrderAdditionalServices = (updateData && updateData.additionalService || order.additionalService)
                .filter((service: AdditionalServiceModel) => !(service.additionalServiceId === 6))
            || [];

        const newUpdateData = isOnHold
            ? {
                additionalService: [onHoldService, ...filteredOrderAdditionalServices]
            }
            : {
                additionalService:  filteredOrderAdditionalServices
            };

        return handleClose(true, newUpdateData);
    }

    return  (
        <StandardDialog headerLabel={<Message messageKey={'keep_on_hold'} sectionId={MessageSections.ORDERS}/>}
                        open={open}>
            <DialogContent>
                <Message messageKey={'keep_on_hold_description'} sectionId={MessageSections.ORDERS}/>
            </DialogContent>


            <StandardDialogFooter saveLabel={<Message messageKey={'ok'} sectionId={MessageSections.MAIN}/>}
                                  onSave={() => setOrderOnHold()}
                                  onCancel={() => handleClose(false)}/>
        </StandardDialog>
    )
}

interface AdditionalServiceOnHoldDialogProps {
    isOnHold: boolean,
    order: OrderModel,
    open: boolean,
    handleClose: (withChange: boolean, existingOrderUpdates?: any) => void,
    updateData?: {[key: string]: any},
}